webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Game = function () {
  function Game(id) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Game);

    this.game = this.getConfig(id);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Game, [{
    key: 'getConfig',
    value: function getConfig(id) {
      return __webpack_require__(26)("./" + id + '.conf').default;
    }
  }, {
    key: 'play',
    value: function play(selection) {
      var data = {};

      // Geting CPU choice
      var cpuSelection = this.randomPlay();

      if (selection === cpuSelection.id) {
        // Check if player tied with CPU
        data.message = selection + ' tied with ' + selection;
        data.tie = selection;
      } else if (cpuSelection.defeat.indexOf(selection) === -1) {
        // Check if player won
        data.message = selection + ' wins ' + cpuSelection.id;
        data.winner = selection;
        data.loser = cpuSelection.id;
      } else {
        // CPU won
        data.message = selection + ' loses ' + cpuSelection.id;
        data.winner = cpuSelection.id;
        data.loser = selection;
      }

      /* return format
        { winner: 'rock' , loser: 'paper' , message: 'rock wins scissors' }
        { tie: 'rock' , message: 'rock with rock' } */
      return data;
    }
  }, {
    key: 'randomPlay',
    value: function randomPlay() {
      return this.game[Math.floor(Math.random() * this.game.length)];
    }
  }]);

  return Game;
}();

/* harmony default export */ __webpack_exports__["a"] = (Game);

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./a.conf": 27,
	"./b.conf": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
  'id': 'rock',
  'defeat': ['scissors']
}, {
  'id': 'paper',
  'defeat': ['rock']
}, {
  'id': 'scissors',
  'defeat': ['paper']
}]);

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
  'id': 'rock',
  'defeat': ['scissors', 'lizard']
}, {
  'id': 'paper',
  'defeat': ['rock', 'spock']
}, {
  'id': 'scissors',
  'defeat': ['paper', 'lizard']
}, {
  'id': 'lizard',
  'defeat': ['paper', 'spock']
}, {
  'id': 'spock',
  'defeat': ['rock', 'scissors']
}]);

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_app_scss__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts__ = __webpack_require__(9);
// Load app style


// Scripts


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Game__ = __webpack_require__(10);


function ready(fn) {
  if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

window.game = null;
var resultFlag = document.getElementById('result');

ready(function () {
  // Loading
  var elem = document.querySelector('div.loading');
  elem.classList.add('is-loaded');
  setTimeout(function () {
    elem.parentNode.removeChild(elem);
  }, 500);

  // Configure choice menu
  document.querySelectorAll('div.choice-game .container .button').forEach(function (obj, id, nodeList) {
    obj.addEventListener('click', function (evt) {
      // Instantiating object
      window.game = new __WEBPACK_IMPORTED_MODULE_0__components_Game__["a" /* default */](obj.getAttribute('game'));
      document.querySelector('section.game').classList.add(obj.getAttribute('game'));
      setTimeout(function () {
        document.querySelectorAll('section.game button.option').forEach(function (obj, id, nodeList) {
          obj.classList.add('in');
        });
      }, 250);

      nodeList.forEach(function (obj) {
        var elem = obj.parentElement.parentElement;
        elem.classList.add('hide');
        elem.classList.remove('show');

        document.querySelector('section.game .button-back').addEventListener('click', function (evt) {
          resultFlag.classList.remove('show');
          resultFlag.classList.remove('hide');
          elem.classList.add('show');
          elem.classList.remove('hide');
          setTimeout(function () {
            document.querySelectorAll('section.game button.option').forEach(function (obj, id, nodeList) {
              obj.classList.remove('in');
              obj.classList.remove('winner');
              obj.classList.remove('loser');
              obj.classList.remove('tie');
            });
            document.querySelector('section.game').classList.remove('a');
            document.querySelector('section.game').classList.remove('b');
            window.game = null;
          }, 250);
        });
      });
    });
  });

  var showResultTimeout;
  var hideResultTimeout;
  var removeClassTimeout;

  document.querySelectorAll('section.game div.container button.option').forEach(function (obj, id, nodeList) {
    obj.addEventListener('click', function (evt) {
      nodeList.forEach(function (obj) {
        obj.classList.remove('winner');
        obj.classList.remove('loser');
        obj.classList.remove('tie');
      });

      if (window.game !== null) {
        var played = window.game.play(obj.getAttribute('play'));
        if (!played.tie) {
          document.getElementById(played.winner).classList.add('winner');
          document.getElementById(played.loser).classList.add('loser');
        } else {
          document.getElementById(played.tie).classList.add('tie');
        }
        resultFlag.classList.add('hide');

        clearTimeout(showResultTimeout);
        clearTimeout(hideResultTimeout);
        clearTimeout(removeClassTimeout);

        showResultTimeout = setTimeout(function () {
          resultFlag.classList.remove('hide');
          resultFlag.innerHTML = played.message;
          resultFlag.classList.add('show');
        }, 50);

        hideResultTimeout = setTimeout(function () {
          resultFlag.classList.remove('show');
          resultFlag.classList.add('hide');
          removeClassTimeout = setTimeout(function () {
            nodeList.forEach(function (obj) {
              obj.classList.remove('winner');
              obj.classList.remove('loser');
              obj.classList.remove('tie');
            });
          }, 3000);
        }, 2000);
      }
    });
  });
});

/***/ })

},[6]);


// WEBPACK FOOTER //
// static/js/app.2fae565a9e72e1fc6c2c.js